import { ChangeDetectionStrategy, Component, inject, output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';

import { UserManagementService } from '@asset-solutions/customer-portal/user-management/data-access';
import { ColorMode } from '@asset-solutions/shared/ui';
import { NotificationService } from '@asset-solutions/shared/utilities';
import { tapResponse } from '@ngrx/operators';

import { RatingComponent } from './rating/rating.component';

@Component({
  selector: 'contact-us-sidebar',
  imports: [FormsModule, MatInputModule, MatSelectModule, MatButton, RatingComponent],
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ContactUsComponent {
  public readonly contactClose = output<void>();
  private readonly notificationService = inject(NotificationService);
  private readonly userManagementService = inject(UserManagementService);
  protected readonly colorMode = inject(ColorMode);

  protected contactFormData = {
    message: '',
    rating: 0,
    subject: ''
  };

  protected submit(): void {
    this.userManagementService
      .sendFeedback(this.contactFormData)
      .pipe(
        tapResponse({
          next: () => {
            this.notificationService.success('Thank you for your feedback');
            this.contactClose.emit();
          },
          error: () => this.notificationService.error('There was an issue submitting your feedback')
        })
      )
      .subscribe();
  }
}
